import React from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import { Elements } from '@stripe/react-stripe-js';
import AppointmentForm from '../components/AppointmentForm';
import { FaCalendarAlt, FaShieldAlt, FaMoneyBillWave } from 'react-icons/fa';

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

const BookAppointment: React.FC = () => {
    return (
        <div className="min-h-screen bg-background">
            {/* Header */}
            <section className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-5xl font-bold mb-4">Book Your Stay</h1>
                    <p className="text-xl opacity-90 max-w-2xl mx-auto">
                        Reserve your perfect getaway at Sunrise Agri Resorts
                    </p>
                </div>
            </section>

            <div className="container mx-auto px-4 py-16">
                {/* Trust Indicators */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    <div className="bg-white p-6 rounded-xl shadow-soft text-center">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FaCalendarAlt className="text-2xl text-primary" />
                        </div>
                        <h3 className="font-semibold text-text mb-2">Easy Booking</h3>
                        <p className="text-sm text-gray-600">Simple booking process</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-soft text-center">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FaShieldAlt className="text-2xl text-primary" />
                        </div>
                        <h3 className="font-semibold text-text mb-2">Secure Booking</h3>
                        <p className="text-sm text-gray-600">Your information is safe with us</p>
                    </div>
                    <div className="bg-white p-6 rounded-xl shadow-soft text-center">
                        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FaMoneyBillWave className="text-2xl text-primary" />
                        </div>
                        <h3 className="font-semibold text-text mb-2">Pay on Arrival</h3>
                        <p className="text-sm text-gray-600">No advance payment required</p>
                    </div>
                </div>

                {/* Booking Form */}
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-2xl shadow-large overflow-hidden">
                        <div className="bg-gradient-to-r from-primary/5 to-accent/5 p-8 border-b border-gray-200">
                            <h2 className="text-3xl font-bold text-text mb-2">Complete Your Reservation</h2>
                            <p className="text-gray-600">Fill in your details below to secure your booking</p>
                        </div>
                        
                        <div className="p-8">
                            {/* Payment Gateway - Commented out for now, will enable next week */}
                            {/* <Elements stripe={stripePromise}>
                                <AppointmentForm />
                            </Elements> */}
                            
                            {/* No payment gateway version */}
                            <AppointmentForm />
                        </div>
                    </div>
                </div>

                {/* Booking Policies */}
                <div className="max-w-4xl mx-auto mt-12">
                    <div className="bg-gray-50 rounded-xl p-8">
                        <h3 className="text-2xl font-bold text-text mb-6">Booking Information</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <h4 className="font-semibold text-text mb-3">Payment Policy</h4>
                                <ul className="space-y-2 text-sm text-gray-600">
                                    <li>• No advance payment required</li>
                                    <li>• Full payment due on check-in</li>
                                    <li>• Cash and card payments accepted at resort</li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="font-semibold text-text mb-3">Cancellation Policy</h4>
                                <ul className="space-y-2 text-sm text-gray-600">
                                    <li>• Free cancellation up to 24 hours before check-in</li>
                                    <li>• Please call us to cancel your booking</li>
                                    <li>• No cancellation fees</li>
                                    <li>• Contact us for special circumstances</li>
                                </ul>
                            </div>
                        </div>
                        <div className="mt-6 pt-6 border-t border-gray-200">
                            <h4 className="font-semibold text-text mb-3">Check-in Information</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                                <div>
                                    <strong>Check-in:</strong> 12:00 PM onwards<br />
                                    <strong>Check-out:</strong> 11:00 AM
                                </div>
                                <div>
                                    <strong>Contact:</strong> +91 9121561555<br />
                                    <strong>Email:</strong> sunriseagriresorts@yahoo.com
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookAppointment;